import React, { createContext, useContext, useState, useCallback } from 'react';

/**
 * Lets FlightInfoPage signal when it has finished loading so TrialPopup
 * can be deferred until after LCP/content is ready (better LCP/TBT on flight-info).
 */
const TrialPopupPageReadyContext = createContext(null);

export function TrialPopupPageReadyProvider({ children }) {
  const [flightInfoPageReady, setFlightInfoPageReadyState] = useState(false);
  const [isTrialPopupOpen, setIsTrialPopupOpen] = useState(false);

  const setFlightInfoPageReady = useCallback((ready) => {
    setFlightInfoPageReadyState(Boolean(ready));
  }, []);

  const value = {
    flightInfoPageReady,
    setFlightInfoPageReady,
    isTrialPopupOpen,
    setIsTrialPopupOpen,
  };

  return (
    <TrialPopupPageReadyContext.Provider value={value}>
      {children}
    </TrialPopupPageReadyContext.Provider>
  );
}

export function useTrialPopupPageReady() {
  const ctx = useContext(TrialPopupPageReadyContext);
  if (!ctx) {
    return {
      flightInfoPageReady: false,
      setFlightInfoPageReady: () => {},
    };
  }
  return ctx;
}
